import Home from 'components/Home';
import Contact from 'components/Contact';
import CV from 'components/CV';
import ErrorPage from 'components/ErrorPage';
import Projects from 'components/Projects';
import Articles from 'components/Articles';
import { contactAction } from 'app/actions';

const routes = [
  {
    path: '/',
    element: <Home />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/contact',
    element: <Contact />,
    errorElement: <ErrorPage />,
    action: contactAction,
  },
  {
    path: '/projects',
    element: <Projects />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/articles',
    element: <Articles />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/cv',
    element: <CV />,
    errorElement: <ErrorPage />,
  },
];

export default routes;
